import React from 'react';
import { useController, useWatch } from 'react-hook-form';
import ControlledAddressAutoCompleteInput from './ControlledAddressAutoCompleteInput';
import ControlledManualAddressInput from './ControlledManualAddressInput';
import styled from 'styled-components';
import { useScreenQuery } from 'playup-web-core';
const ControlledAddressInput = ({ queryPlaceholder, darkMode }: { queryPlaceholder?: string; darkMode?: boolean }) => {
	const countryCode = useWatch({ name: 'country' });
	const { field: isManualAddressField } = useController({
		name: 'isManualAddress',
		defaultValue: false,
	});

	const toggleAddressInputModal = React.useCallback(() => {
		isManualAddressField.onChange(!isManualAddressField.value);
	}, [isManualAddressField]);
	const { isSmall } = useScreenQuery();
	return (
		<div className=" _flex-col _flex">
			<Title darkMode={darkMode} isSmall={isSmall}>
				Address
			</Title>

			{!isManualAddressField.value ? (
				<ControlledAddressAutoCompleteInput
					darkMode={darkMode}
					queryPlaceholder={queryPlaceholder}
					countryCode={countryCode}
					toggleAddressInputModal={toggleAddressInputModal}
				/>
			) : (
				<ControlledManualAddressInput countryCode={countryCode} toggleAddressInputModal={toggleAddressInputModal} />
			)}
		</div>
	);
};

export const Title = styled.span<{ isSmall?: boolean; darkMode?: boolean }>(({ isSmall, darkMode }) => ({
	color: darkMode ? '#a4a6a8' : '#191D22',
	marginBottom: isSmall ? 5 : 7,
	fontSize: isSmall ? 14 : 16,
}));

export default ControlledAddressInput;
